<script setup lang="ts">
import { useStatsigEventsStore } from '@apps/main/new-desktop/core/stores';

import type { FlightProductCardData } from '../../../models';
import AlternativeSuggestionHeader from '../AlternativeSuggestionHeader.vue';

import FlightProductCardContent from './FlightProductCardContent.vue';

interface AlternativeFlightProductCardProps {
  productCardData: FlightProductCardData;
}

const props = defineProps<AlternativeFlightProductCardProps>();

interface FlightProductCardEmits {
  (event: 'show-details'): void;
  (event: 'confirm-alternative'): void;
}

const emit = defineEmits<FlightProductCardEmits>();

const statsigEventsStore = useStatsigEventsStore();

function onAlternativeConfirmButtonClicked(): void {
  statsigEventsStore.logTripOverviewAlternativeFlightSelected();
  emit('confirm-alternative');
}
</script>

<template>
  <div class="alternative-flight-product-card">
    <AlternativeSuggestionHeader
      :info-text="$t('planner.no_availability.messages.alternative_flight')"
      @confirm="onAlternativeConfirmButtonClicked"
    />

    <FlightProductCardContent
      class="alternative-flight-product-card-content"
      :product-card-content="props.productCardData"
      @show-details="emit('show-details')"
      @click="emit('show-details')"
    />
  </div>
</template>

<style scoped lang="scss">
.alternative-flight-product-card {
  border-radius: var(--border-radius-12);
  background: var(--color-white);
  border: 1px solid var(--color-neutral-30);
  overflow: hidden;

  .alternative-flight-product-card-content {
    @include on-hover {
      background: var(--color-neutral-30);
      transition: background var(--transition-short);
      cursor: pointer;
    }
  }
}
</style>
